'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import css from './entries.module.scss';
import { EntryGroup } from './entry-group';
import { ENTRY_STATUS_ORDER, type EntryInfo, type EntryStatus, groupByStatus, parseMetas } from './utils';
export function Entries() {
  const $ = _c(16);
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [allEntries, setAllEntries] = useState(t0);
  const [openStatus, setOpenStatus] = useState("used");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setAllEntries(parseMetas());
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== pathname) {
    t2 = [pathname];
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== allEntries) {
    t3 = groupByStatus(allEntries);
    $[4] = allEntries;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const groups = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = status => {
      setOpenStatus(prev => prev === status ? "" as EntryStatus : status);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleToggle = t4;
  let t5;
  if ($[7] !== allEntries.length) {
    t5 = <p className={css.sectionHeading}>Contentful Entries ({allEntries.length})</p>;
    $[7] = allEntries.length;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== allEntries.length || $[10] !== groups || $[11] !== openStatus) {
    t6 = allEntries.length === 0 ? <p className={css.empty}>No entries found on this page.</p> : <div className={css.groups}>{ENTRY_STATUS_ORDER.map(status_0 => <EntryGroup key={status_0} status={status_0} entries={groups[status_0]} open={openStatus === status_0} onToggle={() => handleToggle(status_0)} />)}</div>;
    $[9] = allEntries.length;
    $[10] = groups;
    $[11] = openStatus;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className={css.column}><div className={css.sidebar}>{t5}{t6}</div></div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}